export interface SysAddressType {
  id: number
  defAddr: boolean
  name: string
  phone: string
  preAddr: string
  code: string
  address: string
  company: string
  sort: number
  enable: boolean
  url: string
}

export interface CommonProblemType {
  id: number
  title: string
  content: string
  created: string
  updated: string
  isContentShow: boolean
}

export const DiaLogType = {
  EXPRESS: 'EXPRESS', // 快递
  SPLASH: 'SPLASH', // 启动页
  OTHER: 'OTHER', // 其他
  RECYCLE_COLOR: 'RECYCLE_COLOR', // 成色表
  ORDER: 'ORDER', // 定价页
}

export interface StartupPageApi {
  img: string
  eventType: DiaLogType
  startTime: string
  endTime: string
  link?: string
}

// 静态资源
export interface AssetsType {
  BUSINESS_DESCRIPTION: string
  START_PAGE: string
  WELCOME_PAGE: string
}
